import { render, staticRenderFns } from "./formation-component.vue?vue&type=template&id=6f0fbeef&"
import script from "./formation-component.vue?vue&type=script&lang=js&"
export * from "./formation-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports